<template>
  <div class="app-skeleton-list" :class="{ 'skeleton-compact': compact }">
    <div
      v-for="n in count"
      :key="'app-skel-' + n"
      class="app-skeleton-card"
      :style="cardStyle"
    >
      <!-- Header do Card Skeleton -->
      <div class="app-skeleton-header">
        <div class="app-skeleton-shimmer skeleton-title-bar" :style="titleStyle"></div>
        <div class="app-skeleton-shimmer skeleton-badge-pill"></div>
      </div>

      <!-- Linha Intermediária (Pills / Badges) -->
      <div v-if="type === 'card'" class="app-skeleton-pills">
        <div class="app-skeleton-shimmer skeleton-doc-pill"></div>
        <div class="app-skeleton-shimmer skeleton-doc-pill"></div>
        <div class="app-skeleton-shimmer skeleton-doc-pill" v-if="!compact"></div>
      </div>

      <!-- Rodapé Financeiro / Detalhes -->
      <div class="app-skeleton-footer">
        <div class="app-skeleton-shimmer skeleton-val-box"></div>
        <div class="app-skeleton-shimmer skeleton-val-box"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AppSkeletonList",
  props: {
    count: {
      type: Number,
      default: 3
    },
    type: {
      type: String,
      default: "card" // 'card' | 'simple' | 'line'
    },
    compact: {
      type: Boolean,
      default: false
    },
    cardHeight: {
      type: [String, Number],
      default: null
    }
  },
  computed: {
    cardStyle() {
      if (!this.cardHeight) return {};
      const h = typeof this.cardHeight === 'number' ? this.cardHeight + 'px' : this.cardHeight;
      return { minHeight: h };
    },
    titleStyle() {
      if (this.compact) return { width: '45%' };
      return { width: '58%' };
    }
  }
};
</script>

<style scoped>
.app-skeleton-list {
  padding: 4px 8px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
}

.app-skeleton-card {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 14px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.03);
}

.skeleton-compact .app-skeleton-card {
  padding: 10px;
  gap: 8px;
}

.app-skeleton-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.app-skeleton-pills {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
}

.app-skeleton-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 4px;
  border-top: 1px dashed #f1f5f9;
}

.app-skeleton-shimmer {
  background: linear-gradient(90deg, #f1f5f9 0%, #e2e8f0 50%, #f1f5f9 100%);
  background-size: 200% 100%;
  animation: appShimmerAnimation 1.5s infinite linear;
  border-radius: 6px;
}

@keyframes appShimmerAnimation {
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}

.skeleton-title-bar {
  height: 16px;
  border-radius: 4px;
}

.skeleton-badge-pill {
  width: 70px;
  height: 18px;
  border-radius: 100px;
}

.skeleton-doc-pill {
  width: 75px;
  height: 20px;
  border-radius: 6px;
}

.skeleton-val-box {
  width: 85px;
  height: 22px;
  border-radius: 6px;
}
</style>
